// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchBar-module__search--ZfIAv{display:flex;align-items:center;width:100%}.SearchBar-module__searchByContainer--wAcYK{display:flex;align-items:center;width:185px}.SearchBar-module__searchByOptions--W6drS{flex-grow:1;border-right:1px solid #c3c5c7;padding-right:15px}.SearchBar-module__searchIcon--UZ86e{width:13px;height:13px}.SearchBar-module__searchAutocomplete--rlf_A,.SearchBar-module__searchInput--X7CqC{margin:0 20px;flex-grow:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `SearchBar-module__search--ZfIAv`,
	"searchByContainer": `SearchBar-module__searchByContainer--wAcYK`,
	"searchByOptions": `SearchBar-module__searchByOptions--W6drS`,
	"searchIcon": `SearchBar-module__searchIcon--UZ86e`,
	"searchAutocomplete": `SearchBar-module__searchAutocomplete--rlf_A`,
	"searchInput": `SearchBar-module__searchInput--X7CqC`
};
export default ___CSS_LOADER_EXPORT___;
